export const APP_BAR_MOBILE = 48;
export const APP_BAR_DESKTOP = 50;
